<template>
	<v-container fluid
		class="report-full-container"
		:class="isScrolled ? 'pt-0' : ''"
		style="max-width: 1400px; margin-left: 0; display: flex; flex-direction: column; overflow: hidden; padding-bottom: 0;"
		:style="'height:'+$store.getters['general/availableHeight']+'px;'">
		<div v-if="loadingReportInfo">
			<p class="text-center caption">Cargando Informe</p>
			<v-skeleton-loader
				type="heading"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="paragraph"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="text"
				class="my-2 mx-6"
			></v-skeleton-loader>
			<v-skeleton-loader
				type="paragraph"
				class="my-2 mx-6"
			></v-skeleton-loader>
		</div>
		<div v-else style="flex: 1; min-height: 0; display: flex; flex-direction: column; overflow: hidden;">
			<v-card class="budget-modal-card mb-2"
				ref="reportHeaderInfo"
				style="flex-shrink: 0;"
				:style="isScrolled ? {
					position: 'sticky',
					top: '0px',
					left: '0',
					right: '0',
					zIndex: 99
				} : {}">
				<v-card-text :class="showReportDetail ? 'pb-2 pt-0' : 'py-0'">
					<div class="project-header" :class="{ 'mb-2': showReportDetail }">
						
						<span class="project-type-badge">Informe</span>

						<div class="project-info">
							<p class="project-code mb-0">{{ reportCode }}</p>
							<p class="project-name mb-0">{{ project?.name || project?.info?.project_detail }}</p>
							<p class="project-name mb-0"><b>Direccion:</b> {{ project?.info?.address?.address }}</p>
						</div>

						<v-tooltip bottom>
							<template v-slot:activator="{ on, attrs }">
								<button class="toggle-btn" v-bind="attrs" v-on="on" @click="toggleReportDetail()">
									<v-icon>{{ showReportDetail ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
									<span>{{ showReportDetail ? 'Ocultar' : 'Ver' }} detalles</span>
								</button>
							</template>
							<span>Ver Detalle</span>
						</v-tooltip>
					</div>
					<div class="d-flex align-start flex-grow-1 caption" v-if="report && showReportDetail">
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Informe</div><span>:</span> <b class="text-end" style="flex: 1;">{{ report.serial?.serial }} - LP{{ report.morphable?.project_line_info?.project_line?.number }} - {{ report.prefix?.prefix }} {{ report.report_index }}</b>
								<div class="action-container">
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Detalle</div><span>:</span>
								<div class="d-flex flex-column flex-grow-1 justify-end">
									<div class="d-flex flex-grow-1 justify-end caption">
										<v-icon x-small class="mr-2">{{getTypeIcon(report.morphable_type)}}</v-icon> <p class="mb-0 font-weight-bold" style="font-size: 10px;">{{ getTypeName(report.morphable_type)}}</p>
									</div>
									<div class="d-flex flex-grow-1 justify-end caption">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<p
													class="mb-0 text-truncate"
													style="max-width: 180px;"
													v-bind="attrs"
													v-on="on"
												>
													{{ report.morphable?.name || report.morphable?.info?.project_detail }}
												</p>
											</template>
											<span>{{ report.morphable?.name || report.morphable?.info?.project_detail }}</span>
										</v-tooltip>
									</div>
								</div>
								<div class="action-container align-start">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												color="warning"
												x-small
												v-bind="attrs"
												v-on="on"
												@click="gotToAssociation(report)"
											>
												<v-icon dark small>mdi-eye-outline</v-icon>
											</v-btn>
										</template>
										<span>Ir al detalle</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Dirección</div><span>:</span>
								<div class="d-flex flex-grow-1 justify-end align-center ml-2">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<p
												class="mb-0 text-truncate caption"
												style="max-width: 200px;"
												v-bind="attrs"
												v-on="on"
											>
												{{ report.morphable?.info?.address?.address }}
											</p>
										</template>
										<span>{{ report.morphable?.info?.address?.address }}</span>
									</v-tooltip>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Estado</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<v-chip
										:color="report.last_status?.status | budgetStatusColor"
										label
										outlined
										x-small
									>
										<b>{{ report.last_status?.status | budgetStatus }}</b>
									</v-chip>
								</div>
								<div class="action-container"></div>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover">
								<div style="width: 120px; min-width: 120px;">Responsable</div><span>:</span> <b class="text-end" style="flex: 1;">{{ userResponsible ? userResponsible:'Sin Responsable' }}</b>
								<div class="action-container">
									<v-menu v-model="responsibleMenu" offset-y z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;">
										<template v-slot:activator="{ on, attrs }">
											<div class="action-container">
												<v-tooltip bottom>
													<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
														<v-btn
															icon
															color="warning"
															x-small
															:disabled="!$checkPermissions(['assign_responsible_user'])"
															v-bind="{ ...attrs, ...tooltipAttrs }"
															v-on="{ ...on, ...tooltipOn }"
														>
															<v-icon dark small>mdi-swap-horizontal-bold</v-icon>
														</v-btn>
													</template>
													<span>Cambiar Responsable</span>
												</v-tooltip>
											</div>
										</template>
										<v-list dense class="py-0" max-height="200" style="z-index: 9999;background-color: white;">
											<v-list-item dense class="mb-1" style="min-height: 25px; background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Cambiar Responsable</p>
											</v-list-item>
											<v-list-item-group color="#524D4D">
												<v-list-item
													v-for="(responsible, index) in $store.state.users.usersList"
													:key="index"
													dense
													@click="changeResponsible(responsible.id)"
												>
													<v-list-item-title dense>
														<div class="d-flex align-center">
															<img :src="responsible.profile.avatar" class="user-avatar mr-2" v-if="responsible?.profile?.avatar"/>
															<v-icon v-else class="user-avatar icon mr-2" color="#524D4D">mdi-account</v-icon>
															<div>
																<p class="mb-0">{{ responsible.profile?.name }} {{ responsible.profile?.lastname }} {{ responsible.profile?.second_lastname }}</p>
																<p class="mb-0 caption">{{ responsible.email }}</p>
															</div>
														</div>
													</v-list-item-title>
												</v-list-item>
											</v-list-item-group>
										</v-list>
									</v-menu>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Cliente</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{clientName}}</p>
								</div>
								<div class="action-container">
									<v-menu v-model="userCompanyMenu" offset-y nudge-left="350px" z-index="9999" :close-on-content-click="false" content-class="menu-bg-white" style="z-index: 9999; background-color: white;"
										v-if="report.morphable?.client?.company_profile && report.morphable?.client?.accreditation?.status">
										<template v-slot:activator="{ on, attrs }">
											<v-tooltip bottom>
												<template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
													<v-btn
														icon
														color="#FF1209"
														x-small
														v-bind="{ ...attrs, ...tooltipAttrs }"
														v-on="{ ...on, ...tooltipOn }"
													>
														<v-icon dark small>mdi-domain</v-icon>
													</v-btn>
												</template>
												<span>Cliente Empresa</span>
											</v-tooltip>
										</template>
										<v-card min-width="400px">
											<v-card-text>
												<div class="caption" v-if="report.morphable?.client?.company_profile">
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre Empresa</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.name}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rut | formatRut}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Teléfono</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.phone}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.address}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Nombre R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rep_name}} {{report.morphable?.client?.company_profile.rep_first_lname}} {{report.morphable?.client?.company_profile.rep_second_lastname}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Email</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.email}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Rut R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rep_rut | formatRut}}</b></div>
													<div class="d-flex justify-space-between mb-1"><div style="width: 150px">Dirección R. Legal</div><span>:</span> <b class="text-end" style="flex: 1;">{{report.morphable?.client?.company_profile.rep_address}}</b></div>
												</div>
											</v-card-text>
										</v-card>
									</v-menu>
									<v-tooltip bottom v-else>
										<template v-slot:activator="{ on, attrs }">
											<v-icon small color="#959595"
												v-bind="attrs"
												v-on="on">mdi-account</v-icon>
										</template>
										<span>Cliente Persona Natural</span>
									</v-tooltip>
								</div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Rut</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{report.morphable?.client?.profile?.rut | formatRut}}</p>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Teléfono</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{report.morphable?.client?.profile?.phone}}</p>
								</div>
								<div class="action-container"></div>
							</div>
							<div class="d-flex justify-space-between mb-1 px-1 item-background-hover flex-grow-1">
								<div style="width: 120px; min-width: 120px;">Email</div><span>:</span>
								<div class="flex-grow-1 justify-end text-end">
									<p class="mb-0 font-weight-bold text-end" style="flex: 1;">{{report.morphable?.client?.email}}</p>
								</div>
								<div class="action-container"></div>
							</div>
						</div>
						<v-divider class="mx-2" vertical></v-divider>
						<div class="d-flex flex-column justify-end align-end" style="width: 270px;min-width: 270px;">
							<div class="d-flex flex-column align-start justify-end" style="width: 100%;">
								<div class="d-flex justify-end align-center mb-1 flex-1" style="width: 100%;">
									<div style="width: 100%;" class="mr-2">
										<v-btn
											depressed
											color="#FF120B"
											class="mb-1 flex-grow-1"
											x-small
											:dark="report.last_status?.status != budgetStatuses.ACEPTADO"
											:disabled="report.last_status?.status == budgetStatuses.ACEPTADO"
											block
											@click="updateReportContentToOnlyOffice"
											:loading="loadingEditorReport"
										>
											<v-icon small>mdi-check</v-icon>
											<p class="mb-0 ml-1 caption">Guardar</p>
										</v-btn>
										<!-- <v-btn
											depressed
											color="#FF120B"
											class="flex-grow-1"
											x-small
											dark
											block
											@click="newWindowOnlyOffice"
										>
											<v-icon small>mdi-open-in-new</v-icon>
											<p class="mb-0 ml-1 caption">Abrir en nueva ventana</p>
										</v-btn> -->
									</div>
									<ReportPdfHistory :report="report" />
								</div>
								<div class="d-flex align-start justify-end" style="width: 100%;">
									<div class="d-flex flex-column align-end justify-end" style="width: 100%;" v-if="userResponsible">
										<div style="width: 100%;">
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														dark
														class="mb-1"
														small
														outlined
														block
														@click="openNewProjectModal(report.morphable, 2)"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-book-outline</v-icon>
														<p class="mb-0 ml-2 caption">Pasar a Presupuesto</p>
													</v-btn>
												</template>
												<span>Genera un nuevo presupuesto para la linea de proyectos</span>
											</v-tooltip>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														outlined
														dark
														class="mb-1"
														small
														block
														@click="startBudgetAssociation"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-book-arrow-left-outline</v-icon>
														<p class="mb-0 ml-2 caption">{{report.associated_budget ? 'Editar Presupuesto Asociado' : 'Asociar Presupuesto'}}</p>
													</v-btn>
												</template>
												<span v-if="report.associated_budget">Edita el presupuesto asociado en este informe.</span>
												<span v-else>Genera y asocia un presupuesto a este informe, podrás insertar la tabla de valores generada en este informe.</span>
											</v-tooltip>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														dark
														class="mb-1"
														small
														outlined
														block
														@click="createContract"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-briefcase-outline</v-icon>
														<p class="mb-0 ml-2 caption">Pasar a Contrato</p>
													</v-btn>
												</template>
												<span>Pasar el informe a contrato</span>
											</v-tooltip>
											<v-tooltip bottom v-if="report.last_status?.status < budgetStatuses.ACEPTADO || report.last_status?.status == budgetStatuses.RECHAZADO">
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														depressed
														color="#959595"
														:dark="!loadingEditorReport"
														small
														outlined
														block
														@click="reportToPdf"
														:loading="loadingEditorReport"
														:disabled="loadingEditorReport"
														v-bind="attrs"
														v-on="on"
													>
														<v-icon small>mdi-file-pdf-box</v-icon>
														<p class="mb-0 ml-2 caption">Generar PDF y Enviar Informe</p>
													</v-btn>
												</template>
												<span>Con esto podrás regenerar el PDF del informe con nueva información</span>
											</v-tooltip>
										</div>
									</div>
									<div v-else>
										<v-chip
											class="wrap-chip text-center"
											color="#FF120B"
											label
											outlined
											x-small
										>
											<b>Para continuar por favor asigna un responsable</b>
										</v-chip>
									</div>
								</div>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
			<v-card :loading="loadingReport" :disabled="loadingReport" class="budget-modal-card" style="flex-shrink: 0;"
				v-if="showReportDetail && report.last_status?.status < budgetStatuses.ACEPTADO"
				ref="reportSecondHeaderInfo"
				:style="isScrolled ? {
					position: 'sticky',
					top: reportHeaderHeight+'px',
					left: '0',
					right: '0',
					zIndex: 9
				} : {}">
				<v-card-text class="py-4">
					<div class="px-2">
						<div class="d-flex align-end justify-space-between mb-2">
							<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
								<p class="mb-0 font-weight-bold caption grey--text">Título</p>
								<div class="d-flex align-center">
									<v-menu
										ref="menu"
										v-model="menuTitle"
										transition="scale-transition"
										offset-y
										left
										nudge-top="-10"
										eager
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												depressed
												color="#524D4D"
												outlined
												dark
												small
												class="d-flex flex-1 mr-2"
												v-bind="attrs"
												v-on="on"
											>
												<div class="d-flex align-center justify-space-between py-2 w-100">
													<p class="mb-0 mr-2">{{report.title ? report.title:'Seleccione Título para el Informe'}}</p>
													<v-icon>mdi-chevron-down</v-icon>
												</div>
											</v-btn>
										</template>
										<div class="white d-flex flex-column">
											<div>
												<v-list class="template-list white" max-height="300px" dense>
													<v-list-item
														class="template-list-item white"
														v-for="(title, i) in $store.state.reports.companiesReportTitles" :key="'bt-' + i"
														@click="onChangeTitle(title.title)">
														<v-list-item-content>
															<v-list-item-title>{{title.title}}</v-list-item-title>
														</v-list-item-content>
														<!-- <v-list-item-action>
															<div class="d-flex align-center">
																<v-tooltip bottom>
																	<template v-slot:activator="{ on, attrs }">
																		<v-btn
																			fab
																			dark
																			x-small
																			icon
																			color="error"
																			@click="deleteTitle(title.id)"
																			v-bind="attrs"
																			v-on="on"
																		>
																			<v-icon small dark>mdi-delete-outline</v-icon>
																		</v-btn>
																	</template>
																	<span>Eliminar</span>
																</v-tooltip>
															</div>
														</v-list-item-action> -->
													</v-list-item>
												</v-list>
											</div>
										</div>
									</v-menu>
									<div
										v-if="menuOpen"
										style="position: fixed;height: 100vh;width:100vw;top:0;left:0;z-index: 8;background-color: rgba(0,0,0,0.2);"
										@click="menuOpen = false"
										></div>
									<v-menu
										v-model="menuOpen"
										bottom
										offset-y
										right
										min-width="500"
										max-width="500"
										content-class="container-notification-menu-header"
										:close-on-content-click="false"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												icon
												dark
												small
												color="#959595"
												v-bind="attrs"
												v-on="on"
											>
												<v-icon dark>mdi-cog-outline</v-icon>
											</v-btn>
										</template>
										<div class="white" style="position: relative;">
											<div dense class="d-flex align-center justify-space-between px-2 py-1" style="background: #959595;">
												<p class="caption mb-0 font-weight-bold white--text">Configuración Títulos</p>
												<v-tooltip bottom>
													<template v-slot:activator="{ on, attrs }">
														<v-btn icon color="white" class="mr-3"
																	v-bind="attrs"
																	v-on="on"
																	small
																	@click="setReportTitle(null)">
															<v-icon>mdi-plus</v-icon>
														</v-btn>
													</template>
													<span>Nuevo título para Informes</span>
												</v-tooltip>
											</div>
											<div class="px-2 py-1">
												<v-list class="pt-0" style="max-height: 300px;overflow: scroll;">
													<v-list-item
														v-for="(item, i) in $store.state.reports.companiesReportTitles"
														:key="i"
														class="px-0 py-0"
													>
														<div style="width: 100%">
															<div class="d-flex flex-row px-2 pt-2 justify-space-between">
																<div class="pr-4 caption">
																	<p class="mb-0 caption font-weight-bold" style="color: #707070;">{{ item.title }}</p>
																</div>
																<div>
																	<v-tooltip bottom>
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn
																				icon
																				dark
																				x-small
																				color="warning"
																				@click="setReportTitle(item)"
																				v-bind="attrs"
																				v-on="on"
																			>
																				<v-icon small dark>mdi-pencil</v-icon>
																			</v-btn>
																		</template>
																		<span>Editar Título</span>
																	</v-tooltip>
																	<v-tooltip bottom>
																		<template v-slot:activator="{ on, attrs }">
																			<v-btn
																				icon
																				dark
																				x-small
																				color="error"
																				@click="deleteBugdetTitle(item)"
																				v-bind="attrs"
																				v-on="on"
																			>
																				<v-icon small dark>mdi-delete-outline</v-icon>
																			</v-btn>
																		</template>
																		<span>Eliminar Título</span>
																	</v-tooltip>
																</div>
															</div>
														</div>
													</v-list-item>
												</v-list>
											</div>
										</div>
									</v-menu>
								</div>
							</div>
							<v-divider vertical class="mx-6"></v-divider>
							<div class="d-flex flex-1 flex-column flex-grow-1" style="flex-basis:50%;">
								<p class="mb-0 font-weight-bold caption grey--text">Plantillas</p>
								<CompanyTemplatesHandler
									:type="'onlyoffice_report'"
									:itemContent="report"
									:itemContentHtml="htmlUpdatedContent"
									@template-content-selected="templateContentSelected"
									@request-html-content="requestHtmlContentOnlyOffice"/>
							</div>
							<v-divider vertical class="mx-2"></v-divider>
							<v-tooltip bottom v-if="report.associated_budget">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										depressed
										:color="highlightAddBudgetCostsButton ? 'green' : '#959595'"
										:outlined="!highlightAddBudgetCostsButton"
										dark
										small
										class="mr-1"
										@click="setBudgetHtmlToOnlyOffice"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small>mdi-book-arrow-left-outline</v-icon>
										<p class="mb-0 ml-2 caption">Insertar Costos Presupuesto</p>
									</v-btn>
								</template>
								<span>Inserta en el informe, en la posición actual del cursor, la tabla con los costos del presupuesto asociado.</span>
							</v-tooltip>
							<ProjectLineDocumentsMenu :project_line_id="project?.project_line_info?.project_line_id" :size="'small'"/>
						</div>
						<v-divider class="my-1"></v-divider>
					</div>
				</v-card-text>
			</v-card>
			<!-- <ReportTextEditor ref="reportTextEditorRef" v-if="report && selectedCompany && showEditor" :report="report"/> -->
			<!-- <div
				class="d-flex flex-1 mt-2"
				:style="{ height: availableHeight + 'px' }"
			> -->
			<div class="d-flex mt-2" style="flex: 1; min-height: 0; overflow: hidden;">
				<div v-if="report && report.pdf && report.pdf.file && report.last_status?.status == budgetStatuses.ACEPTADO" style="flex: 1; min-height: 0; display: flex;">
					<iframe :src="report.pdf.file.file_link" width="100%" style="flex: 1; min-height: 0; border: none;"></iframe>
				</div>
				<OnlyOfficeEditor
					v-else-if="report && selectedCompany && showEditor"
					ref="onlyofficeEditor"
					:document-id="report.only_office_document?.only_office_id"
					height="100%"
					@documentStateChange="handleDocumentStateChange"
				/>
			</div>
		</div>
		<AcceptCancelModal
			:acceptRejectModal="showAssociateBudgetModal"
			:acceptRejectModalData="budgetAssociationData"
			:closeModal="closeAssociateBudgetModal"
		/>
	</v-container>
</template>

<script>
import { initializeApp } from "firebase/app";
import { getDatabase, ref, set, onValue } from "firebase/database";
import _debounce from 'lodash/debounce'

import budgetStatuses from '@/components/Helpers/Constants/budget.js'
import {getReportById, createReportPdfFromPreview, sendReportPdfEmail, updateReport, deleteReportTitle, forceReportHeaderGeneration} from '@/helpers/api/reports'
import {createBudget} from '@/helpers/api/budgets'
import {deleteVTReportTemplate} from '@/helpers/api/general'
import { createContract } from '@/helpers/api/contracts'

import {setResponsible as setResponsiblePreProject} from '@/helpers/api/preprojects'
import {setResponsible as setResponsibleProject} from '@/helpers/api/projects'
import {editCrmResponsible} from '@/helpers/api/crm'
import { eventBus } from '@/components/Helpers/Events/NotificationsEventBus'

import AcceptCancelModal from '@/components/Modals/General/AcceptCancelModal'
import CompanyTemplatesHandler from '@/components/Helpers/Components/CompanyTemplatesHandler'
// import ReportTextEditor from '@/components/Helpers/Editor/ReportTextEditor.vue'
import ReportPdfHistory from '@/components/Helpers/Components/ReportPdfHistory'
import OnlyOfficeEditor from '@/components/Helpers/Editor/OnlyOfficeEditor.vue';
import ProjectLineDocumentsMenu from '@/components/Views/Projects/Parts/ProjectLineDocumentsMenu'

export default {
	name: 'ReportDetail',
	components: {ReportPdfHistory, OnlyOfficeEditor, CompanyTemplatesHandler, ProjectLineDocumentsMenu, AcceptCancelModal},
	computed: {
		project(){
			return this.report?.morphable
		},
		reportCode() {
			return `${this.report.serial?.serial} - LP${this.project?.project_line_info?.project_line?.number} - ${this.report.prefix?.prefix} ${this.report.report_index}`
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		},
		openReportModal(){
			return this.$store.state.general.newReportModal
		},
		userResponsible(){
			if(this.report.morphable?.responsible?.profile){
				let fullName = this.report.morphable?.responsible?.profile?.name
				if(this.report.morphable?.responsible?.profile?.lastname){
					fullName = fullName + ' ' + this.report.morphable?.responsible?.profile?.lastname + ' ' + this.report.morphable?.responsible?.profile?.second_lastname
				}
				return fullName
			}
			return null
		},
		clientName(){
			let client_name = 'No Disponible'
			if(this.report.morphable?.client?.profile){
				client_name = this.report.morphable.client.profile.name + ' ' + this.report.morphable.client.profile.lastname + ' ' + this.report.morphable.client.profile.second_lastname
			}
			else if(this.getType(this.report.morphable_type) == 'crm' && this.report.morphable?.user){
				if(this.report.morphable.user?.user?.profile){
					client_name = (this.report.morphable.user?.user?.profile?.name ?? '') + ' ' + 
									(this.report.morphable.user?.user?.profile?.lastname ?? '') + ' ' + 
									(this.report.morphable.user?.user?.profile?.second_lastname ?? '')
				}
				else{
					client_name = (this.report.morphable.user.name ?? '') + ' ' +
												(this.report.morphable.user.lastname ?? '') + ' ' +
												(this.report.morphable.user.second_lastname ?? '')
				}
			}
			return client_name
		},
		item(){
			return this.$store.state.general.newReportModal.item
		},
		queryRoute(){
			return this.$route.query
		},
		reportHeaderHeight(){
			return this.$store.state.reports.reportHeaderHeight
		},
		reportSecondHeaderHeight(){
			return this.$store.state.reports.reportSecondHeaderHeight
		},
		// availableHeight(){
		// 	const availableHeight = this.$store.getters['general/availableHeight'] - this.reportHeaderHeight - this.reportSecondHeaderHeight - 48
		// 	return availableHeight
		// },
		availableHeight(){
			const secondHeader = this.showReportDetail ? this.reportSecondHeaderHeight : 0
			const availableHeight = this.$store.getters['general/availableHeight'] 
				- this.reportHeaderHeight 
				- secondHeader 
				- 48  // margen mt-2 + padding
			return Math.max(availableHeight, 400)
		},
		isScrolled(){
			return this.$store.state.reports.scrolledReport > 0
		},
		budgetAssociationData() {
			return {
				title: 'Asociar Nuevo Presupuesto',
				content_a: '¿Estás seguro de que deseas asociar un nuevo presupuesto?',
				content_b: 'El informe se asociará al nuevo presupuesto y podrás insertar la tabla de valores generada en este informe.',
			}
		},
	},
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.$store.dispatch('users/getUserFromCompany')
				this.$store.dispatch('reports/getReportTitles')
				this.$store.dispatch('vt/getVtReportTemplates')
			}
		},
		queryRoute(){
			const report_id = this.$route.query.id
			if(this.report && this.report.id != report_id){
				this.report = null
				this.getReportInfo()
			}
		},
		report(){
			if(this.report){
				this.showEditor = false
				this.$nextTick(() => {
					this.showEditor = true
				})
			}
		},
		loadingReportInfo(val){
      if (!val) {
        this.$nextTick(() => {
          this.initResizeObserver();
        });
      }
		}
	},
  data() {
    return {
			budgetStatuses,
			menuOpen: false,
			userCompanyMenu: false,
			showEditor: false,
			menuTitle: false,
			menuTemplates: false,
			prefixMenu: false,
			loadingReportInfo: true,
			responsibleMenu: false,
			loadingReport: false,
			report_id: null,
			report: null,
      resizeObserver: null,
			showReportDetail: false,
			firebaseApp: null,
			firebaseDatabase: null,
			loadingEditorReport: false,
			htmlUpdatedContent: null,
			showAssociateBudgetModal: false,
			highlightAddBudgetCostsButton: false,
			budgetCheckInterval: null
		}
	},
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
    if (this.budgetCheckInterval) {
      clearInterval(this.budgetCheckInterval);
    }
		this.stopListenToOnlyOfficeMessagesInRTDB()
  },
	mounted(){
		if(this.selectedCompany){
			this.$store.dispatch('users/getUserFromCompany')
			this.$store.dispatch('reports/getReportTitles')
			this.$store.dispatch('vt/getVtReportTemplates')
		}
		this.getReportInfo()
		this.initResizeObserver()
		eventBus.$on('reloadInformation', this.handleReloadInformation)
		this.initFirebase()
	},
	beforeDestroy() {
		eventBus.$off('reloadInformation', this.handleReloadInformation)
		if (this.firebaseDatabase) {
			this.firebaseDatabase = null
		}
		if (this.firebaseApp) {
			this.firebaseApp = null
		}
	},
	methods: {
		handleReloadInformation(report_info){
			if(report_info && this.report && report_info.report_id == this.report.id){
				this.getReportInfo()
			}
		},
		templateContentSelected(template){
			this.onChangeReportsTemplateToOnlyOffice(template)
		},
		initFirebase() {
			this.firebaseApp = initializeApp({
				apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
				authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
				databaseURL: process.env.VUE_APP_FIREBASE_RTDB_URL,
				projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
				storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
				messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
				appId: process.env.VUE_APP_FIREBASE_APP_ID
			})
			this.firebaseDatabase = getDatabase(this.firebaseApp)
		},
		listenToOnlyOfficeMessagesInRTDB(){
			const path = `onlyofficedocs/${this.report.only_office_document.only_office_id}`
			const dbRef = ref(this.firebaseDatabase, path)
			onValue(dbRef, (snapshot) => {
				const data = snapshot.val();
				const loadingEditor = data ? data.loadingEditor : null;
				const notAllowedCursorPositionToPasteHtml = data ? data.notAllowedCursorPositionToPasteHtml : null;
				const htmlDocumentContent = data ? data.htmlContent : null;
				if(loadingEditor){
					this.loadingEditorReport = true
				}
				else if(notAllowedCursorPositionToPasteHtml){
					this.loadingEditorReport = false
					this.setMessage({
						message: 'No es posible pegar contenido en la posición actual del cursor. Por favor, posiciona el cursor en un lugar permitido del documento.',
						title: 'Error al pegar contenido',
						type: 'warning',
						icon: 'mdi-alert-circle-outline',
						color: '#FFA800',
						close: 8000
					})
					set(dbRef, null)
				}
				else if(htmlDocumentContent){
					this.htmlUpdatedContent = htmlDocumentContent
					this.loadingEditorReport = false
					set(dbRef, null)
				}
				else{
					this.loadingEditorReport = false
					set(dbRef, null)
				}
			});
		},
		stopListenToOnlyOfficeMessagesInRTDB(){
			if (this.firebaseDatabase) {
				const path = `onlyofficedocs/${this.report.only_office_document.only_office_id}`
				const dbRef = ref(this.firebaseDatabase, path)
				onValue(dbRef, () => {});
			}
		},
		toggleReportDetail(){
			this.showReportDetail = !this.showReportDetail
		},
		newWindowOnlyOffice(){
			const only_office_id = this.report.only_office_document?.only_office_id
			const onlyOfficeUrl = window.location.origin + '/document-editor/' + only_office_id
			window.open(onlyOfficeUrl, '_blank')
		},
		onScroll(event){
			this.$store.commit('reports/setScrolledReport', event.target.scrollTop)
		},
    initResizeObserver() {
      const el = this.$refs.reportHeaderInfo?.$el || this.$refs.reportHeaderInfo;
			const el2 = this.$refs.reportSecondHeaderInfo?.$el || this.$refs.reportSecondHeaderInfo;
      if (!el || !el2) return;

      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }

      this.resizeObserver = new ResizeObserver(() => {
				this.$store.commit('reports/setReportHeaderHeight', el.offsetHeight)
				this.$store.commit('reports/setReportSecondHeaderHeight', el2.offsetHeight)
      });

      this.resizeObserver.observe(el);
    },
		async getReportInfo(){
			try {
				const report = await getReportById({report_id: this.$route.query.id})
				if(report.code == 200){
					this.report = report.report
					this.listenToOnlyOfficeMessagesInRTDB()
				}
				this.loadingReportInfo = false
			} catch (error) {
				if(error.status == 404){
					const messageData = {
						message: 'Hubo un error al acceder a este contenido, por favor intenta nuevamente.',
						title: 'Error de acceso',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
					}
					this.setMessage(messageData)
					this.$router.replace({ name: 'Reports' })
				}
			}
		},
		reverseContentViewToPlaceholders(content) {
			let result = content;
			result = result.replace(/<span id="(.*?)"[^>]*>(.*?)<\/span>/g, (match, placeholder) => {
					return `${placeholder}`;
			})
			return result;
		},
		handleDocumentStateChange(info){
			if(!info.data){
				this.updateReportContentToOnlyOffice()
			}
		},
		async reportToPdf(){
			// const contentEditorRef = this.$store.state.reports.reportEditorRef
			// const data = {
			// 	report_id: this.report.id,
			// 	contents: JSON.stringify( contentEditorRef.pages.map(page => page.prev_innerHTML) )
			// }
			const data = {
				report_id: this.report.id,
				// contents: JSON.stringify( contentEditorRef.pages.map(page => this.reverseContentViewToPlaceholders(page.prev_innerHTML) ) )
			}
			const pdf = await createReportPdfFromPreview(data)
			if(pdf.code == 200){
				const report = {...this.report, ...{pdf: pdf.report_pdf}}
				this.$store.commit('reports/setReportPdfModal', report)
				// this.getReportInfo()
			}
		},
		getType(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'crm'
				case "App\\Models\\PreProject":
					return 'preproject'
				case "App\\Models\\Project":
					return 'project'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeIcon(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'mdi-contacts-outline'
				case "App\\Models\\PreProject":
					return 'mdi-information-variant-circle-outline'
				case "App\\Models\\Project":
					return 'mdi-ruler-square'
				default:
					break;
			}
			return 'Otro'
		},
		getTypeName(type){
			switch (type) {
				case "App\\Models\\BotConversation":
					return 'CRM'
				case "App\\Models\\PreProject":
					return 'PreProyecto'
				case "App\\Models\\Project":
					return 'Proyecto'
				default:
					break;
			}
			return 'Otro'
		},
    setMessage(messageData){
      const data = {
        message: messageData.message,
        title: messageData.title,
        created: new Date(),
        type: messageData.type,
        icon: messageData.icon,
        color: messageData.color,
				close: messageData.close || 5000,
      }
      this.$store.dispatch('general/addMessage', data)
    },
		gotToAssociation(item){
			const item_type = this.getType(item.morphable_type)
			if(item_type == 'crm'){
				// this.$router.push({ name: 'Conversation', params: { id: item.morphable_id } })
				this.$store.commit('crm/setCrmModalId', item.morphable_id )
			}
			else if(item_type == 'preproject'){
				// this.$router.push({ name: 'PreProject', params: { id: item.morphable_id } })
				this.$store.commit('preprojects/setPreProjectModalId', item.morphable_id)
			}
			else if(item_type == 'project'){
				const messageData = {
					message: 'Detalle de proyectos en futuro módulo Proyectos',
					title: 'Sección en construcción',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		changeResponsible: _debounce(function(responsible_id) { this._changeResponsible(responsible_id) }, 800),
		async _changeResponsible(responsible_id){
			const item_type = this.getType(this.report.morphable_type)
			if(item_type == 'crm'){
				// await assignScheduleToUser({schedule_id: this.report.morphable.schedule.user_schedule.id, new_user_id: responsible_id})
				await editCrmResponsible({conversation_id: this.report.morphable_id, responsible_id})
			}
			else if(item_type == 'preproject'){
				await setResponsiblePreProject({preproject_id: this.report.morphable_id, responsible_id})
			}
			else if(item_type == 'project'){
				await setResponsibleProject({project_id: this.report.morphable_id, responsible_id})
			}
			await forceReportHeaderGeneration({report_id: this.report.id})
			this.getReportInfo()
			this.responsibleMenu = false
		},
		async sendEmailReport(){
			const report_r = await sendReportPdfEmail({report_id: this.report.id})
			if(report_r.code === 200){
				const messageData = {
					message: 'Se ha enviado correctamente el presupuesto por correo',
					title: 'Presupuesto enviado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
    async createContract(){
      if(this.report.morphable_id){
				if(this.getType(this.report.morphable_type) != 'project'){
					this.openNewProjectModal({
						...this.report.morphable,
						morphable_type: this.getType(this.report.morphable_type),
					},
					1)
					return null
				}
				const data = {
					item_type: this.getType(this.report.morphable_type),
					item_id: this.report.morphable_id
				}
        const contract = await createContract(data)
        if(contract.code === 200){
					if(contract.existent){
						const source = contract.contract || contract.budget;
						if (source) {
							const dataInfo = {
								...source,
								doc_type: 1,
							};
							this.$store.commit('general/setExistentDocumentNotificationModalData', dataInfo);
							this.$store.commit('general/setExistentDocumentNotificationModal', true);
						}
						return
					}
          const messageData = {
            message: 'Se ha creado correctamente el contrato',
            title: 'Contrato creado',
            type: 'success',
            icon: 'mdi-check-circle',
            color: '#3EBFA3',
          }
					this.$store.commit('contracts/setContractComponentModalId', contract.contract.id)
					// this.$router.push({ name: 'ContractDetail', query: { id: contract.contract.id } })
          this.setMessage(messageData)
        }
        else{
          const messageData = {
            message: 'Hubo un error en la operación, por favor intenta nuevamente',
            title: 'Ha ocurrido un error',
						type: 'danger',
						icon: 'mdi-close-octagon',
						color: '#FF1209',
          }
          this.setMessage(messageData)
        }
      }
    },
		compareAssociatedBudgets(previous, current) {
			if (!previous && !current) return false;
			if (!previous || !current) return true;
			
			// Comparar propiedades clave del presupuesto
			return JSON.stringify(previous) !== JSON.stringify(current);
		},
		async startBudgetAssociation(){
			if(this.report.associated_budget){
				// Guardar estado inicial del presupuesto
				const previousAssociatedBudget = JSON.parse(JSON.stringify(this.report.associated_budget));
				
				this.highlightAddBudgetCostsButton = true
				const popup = window.open(`/built-in-content?type=budget&id=${this.report.associated_budget.id}&from=report`, '', 'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no')
				
				// Guardar el interval para poder limpiar después
				this.budgetCheckInterval = setInterval(async () => {
					if (popup.closed) {
						clearInterval(this.budgetCheckInterval);
						this.budgetCheckInterval = null;
						
						// Recargar información del reporte
						await this.getReportInfo();
						
						// Comparar cambios
						const hasChanges = this.compareAssociatedBudgets(previousAssociatedBudget, this.report.associated_budget);
						
						if (hasChanges) {
							// Mantener botón verde y mostrar notificación
							this.highlightAddBudgetCostsButton = true;
							this.setMessage({
								message: 'Se detectaron cambios en el presupuesto asociado. Puedes insertar los costos en el informe.',
								title: 'Presupuesto actualizado',
								type: 'success',
								icon: 'mdi-check-circle',
								color: '#3EBFA3'
							});
						} else {
							// Sin cambios, volver al estado inicial (gris)
							this.highlightAddBudgetCostsButton = false;
						}
					}
				}, 500);
				return
			}
			this.showAssociateBudgetModal = true
		},
		async setBudgetHtmlToOnlyOffice(){
			if (!this.firebaseApp) {
				this.initFirebase()
			}
			const report = await getReportById({report_id: this.$route.query.id})
			if(report.code == 200){
				const budget_content = report.report.associated_budget
				const content = this.associatedBudgetHtml(budget_content)
				const path = `onlyofficedocs/${this.report.only_office_document.only_office_id}`
				const dbRef = ref(this.firebaseDatabase, path)
				await set(dbRef, {html: content})
				this.highlightAddBudgetCostsButton = false
			}
		},
		associatedBudgetHtml(content){
			let content_final = `
					<p style="margin-top: 16px; margin-bottom: 8px; font-weight: bold; font-size: 15px; font-family: 'Arial Narrow'; text-transform: uppercase;">Presupuesto</p>
					<table style="width: 100%; margin-bottom: 16px; background-color: white; border-collapse: separate; border-spacing: 0; font-size: 13px; font-family: 'Arial Narrow'; text-transform: uppercase;">
							<thead>
									<tr style="background-color: #f0f0f0;">
											<td style="width: 36%; padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-left: 1px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">Concepto</td>
											<td style="width: 26%; padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">Detalle</td>
											<td style="width: 19%; padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">UF</td>
											<td style="width: 19%; padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">Pesos</td>
									</tr>
							</thead>
							<tbody>
			`
			let total = 0
			const uf_value = content?.uf_value ? content.uf_value.uf_value : 0;
			content.categories.forEach((category, index) => {
					content_final += `
							<tr>
									<td colspan="4" style="background-color: #6b6b6b; padding: 6px 10px; border-bottom: 1px solid #555555; border-left: 1px solid #555555; border-right: 1px solid #555555;">
											<span style="font-weight: bold; color: white; font-size: 12px; font-family: 'Arial Narrow';">${ (index + 1) + 'º ETAPA - ' + category.name }</span>
									</td>
							</tr>
					`
					category.parts.forEach((part, partIndex) => {
							const value = Number(part.value);
							if (!isNaN(value)) {
									total += value;
							}
							const rowBg = partIndex % 2 === 0 ? '#ffffff' : '#f9f9f9';
							content_final += `
									<tr style="background-color: ${rowBg};">
											<td style="padding: 7px 10px; border-bottom: 1px solid #e0e0e0; border-left: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; font-family: 'Arial Narrow';">${ part.concept }</td>
											<td style="padding: 7px 10px; color: #555555; border-bottom: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; font-family: 'Arial Narrow';">${ part.detail ?? '--' }</td>
											<td style="padding: 7px 10px; border-bottom: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; font-family: 'Arial Narrow';">${ this.$options.filters.toThousandFilter(part.value) } + IVA</td>
											<td style="padding: 7px 10px; font-weight: bold; border-bottom: 1px solid #e0e0e0; border-right: 1px solid #e0e0e0; font-family: 'Arial Narrow';">${ this.$options.filters.toThousandFilter(part.value * uf_value) } + IVA</td>
									</tr>
							`
					})
			})

			content_final += `
							<tr style="background-color: #f0f0f0;">
									<td colspan="2" style="padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-left: 1px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">Total Presupuesto</td>
									<td style="padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">${ this.$options.filters.toThousandFilter(total) } + IVA</td>
									<td style="padding: 8px 10px; font-weight: bold; border-top: 2px solid #cccccc; border-bottom: 2px solid #cccccc; border-right: 1px solid #cccccc; font-family: 'Arial Narrow';">${ this.$options.filters.toThousandFilter(total * uf_value) } + IVA</td>
							</tr>
							</tbody>
					</table>`
			return content_final
		},
		closeAssociateBudgetModal(confirmed = false) {
			if (confirmed) {
				this.createBudgetFromReport()
			}
			this.showAssociateBudgetModal = false
		},
		async createBudgetFromReport(){
			const typeMap = {
				'App\\Models\\BotConversation': 'crm',
				'App\\Models\\PreProject': 'preproject',
				'App\\Models\\Project': 'project'
			}
			const item_type = typeMap[this.report.morphable_type]
			const item_id = this.report.morphable_id
			const new_budget = await createBudget({
				report_id: this.report.id,
				budget_prefix_id: this.report.prefix_id,
				item_type,
				item_id
			})
			if(new_budget.code === 200){
				this.highlightAddBudgetCostsButton = true
				window.open(`/built-in-content?type=budget&id=${new_budget.budget.id}`, '', 'width=1000,height=700,toolbar=no,menubar=no,location=no,status=no')
				this.getReportInfo()
				const messageData = {
					message: 'Se ha creado correctamente el presupuesto',
					title: 'Presupuesto creado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			else{
				const messageData = {
					message: 'Hubo un error en la operación, por favor intenta nuevamente',
					title: 'Ha ocurrido un error',
					type: 'danger',
					icon: 'mdi-close-octagon',
					color: '#FF1209',
				}
				this.setMessage(messageData)
			}
		},
		openNewProjectModal(preproject, doc_type){
			console.log('this.project.doc_type', doc_type)
			const pre_project = {
				...this.report.morphable,
				...{doc_type},
				morphable_type: this.getType(this.report.morphable_type),
				from_budget_id: this.report.associated_budget_id
			}
			this.$store.commit('projects/setProjectModalInfo', pre_project)
			this.$store.commit('projects/setProjectModal', true)
		},
		async editReportTemplate(reportTemplate, duplicating = false){
			const rt = {...reportTemplate}
			if(duplicating){
				rt.name = rt.name + ' (Copia)'
				delete rt.id
			}
			this.$store.commit('vt/setNewReportTemplateEditing', rt)
      this.$store.commit('vt/setNewReportTemplateModal', true)
		},
		async deleteVTReportTemplates(template_id){
			await deleteVTReportTemplate({template_id})
			this.$store.dispatch('vt/getVtReportTemplates')
		},
		async onChangeReportsTemplateToOnlyOffice(template){
			if (!this.firebaseApp) {
				this.initFirebase()
			}
			const path = `onlyofficedocs/${this.report.only_office_document.only_office_id}`
			const dbRef = ref(this.firebaseDatabase, path)
			await set(dbRef, {html: template.content})
		},
		async requestHtmlContentOnlyOffice(){
			if (!this.firebaseApp) {
				this.initFirebase()
			}
			const path = `onlyofficedocs/${this.report.only_office_document.only_office_id}`
			const dbRef = ref(this.firebaseDatabase, path)
			await set(dbRef, {htmlContentRequest: true})
		},
		async onChangeReportTemplate(template){
			this.menuTemplates = false
			const response = await updateReport({
				report_id: this.report.id,
				report_html: template.content
			})
			if(response.code == 200){
				this.$refs.onlyofficeEditor.reloadEditor()
				const messageData = {
					message: 'Contenido del informe guardado',
					title: 'Informe guardado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
			// setTimeout(() => {
			// 	this.$refs.reportTextEditorRef.setTemplate(template)
			// 	this.$nextTick(() => {
			// 		setTimeout(() => {
			// 			this.updateReportContent()
			// 	}, 200)
			// 	})
			// }, 200)
		},
		async updateReportContentToOnlyOffice(){
			if (!this.firebaseApp) {
				this.initFirebase()
			}
			this.loadingEditorReport = true
			const path = `onlyofficedocs/${this.report.only_office_document.only_office_id}`
			const dbRef = ref(this.firebaseDatabase, path)
			await set(dbRef, {saveDoc: true})
		},
		async updateReportContent(){
			const contentEditorRef = this.$store.state.reports.reportEditorRef
			const response = await updateReport({
				report_id: this.report.id,
				report_html: contentEditorRef.pages.map(page => this.reverseContentViewToPlaceholders(page.prev_innerHTML))
			})
			if(response.code == 200){
				const messageData = {
					message: 'Contenido del informe guardado',
					title: 'Informe guardado',
					type: 'success',
					icon: 'mdi-check-circle',
					color: '#3EBFA3',
				}
				this.setMessage(messageData)
			}
		},
		async onChangeTitle(title){
			this.report = {...this.report, ...{title}}
			await updateReport({
				report_id: this.report.id,
				title
			})
			this.getReportInfo()
		},
		setReportTitle(title = null){
			this.$store.commit('reports/setNewReportTitleModalEditing', title ? {...title, ...{report_title_id: title.id}}:null)
      this.$store.commit('reports/setNewReportTitleModal', true)
		},
		async deleteBugdetTitle(title){
			await deleteReportTitle({report_title_id: title.id})
			this.$store.dispatch('reports/getReportTitles')
		},
	}
}
</script>

<style>
	.report-full-container{
		position: relative;
	}
	.v-dialog.budget-modal-custom{
		max-width: 1200px;
		width: 90vw;
		height: 95vh;
		max-height: 95vh;
	}
	.budget-note-tiny-editor {
		max-height: 140px !important;
		overflow: auto !important;
	}
</style>

<style scoped>
	.action-container{
		width: 30px;
		display: flex;
		align-items: center;
		justify-content: flex-end;
	}
	.custom-warning-observation{
		border: 1px solid #fb8c00;
		border-radius: 6px;
	}
	/deep/ .budget-note-container p{margin-bottom: 0;}

.project-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 4px 0;
}

.project-type-badge {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #9e9a9a;
  flex-shrink: 0;
}

.project-info {
  flex: 1;
  border-left: 1px solid #e0dcdc;
  padding-left: 12px;
}

.project-code {
  font-size: 16px;
  font-weight: 700;
  color: #2c2828;
  line-height: 1.3;
}

.project-name {
  font-size: 12px;
  color: #7a7575;
  line-height: 1.4;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.toggle-btn {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  background: transparent;
  border: 1px solid #d6d1d1;
  border-radius: 4px;
  cursor: pointer;
  color: #524D4D;
  font-size: 13px;
  white-space: nowrap;
  transition: background 0.15s, border-color 0.15s;
}

.toggle-btn:hover {
  background: #eeebeb;
  border-color: #524D4D;
}
</style>